module.exports = __webpack_public_path__ + "img/derecho-natural.ad776432.svg";